import sectionFaqGridCss from '../css-snippets/section-faq-grid';

const html = `
<style>${sectionFaqGridCss}</style>
<div data-container="faq-grid-container-fluid-unique-id" data-id="unique-id" data-attribute="faq-grid-container-fluid" data-top-padding="true" data-bottom-padding="true"
  data-background="#ffffff" class="faq-grid-container-fluid" style="background-color: #ffffff;">
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <h2 data-attribute="title-faq-grid" data-color="#000000" class="title-faq-grid" style="color: #000000;">
      <strong>Frequently Asked Questions</strong>
    </h2>
    <div data-attribute="list-item" class="list-item" data-background-items="#eaf4f9">
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">Will this
            provide long term relief?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            That's exactly why we created this device. We noticed plenty of devices on the market offering
            short-term relief, but none provided a long-term solution. That's why we developed our own
            device to
            address neck pain, stiffness, headaches, neck humps, and forward head posture for lasting
            results.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">What types
            of pain can it relieve?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Hugterra Belt is ideal for relieving lower back pain, sciatica, herniated discs, spinal
            compression, muscle tightness, and hip or leg pain caused by nerve pressure.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">Can I use
            it anywhere?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Yes, the Hugterra Belt is completely portable & requires no cables.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">What if it
            doesn't work for me?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The Hugterra™ Belt comes with a 60-day money-back guarantee that starts only when you receive
            the product. We're offering this guarantee because we're confident that our product works. If
            you're not completely satisfied with the results, contact our support team at
            contact@hugterra.com for a refund.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">How fast
            will I feel better?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The pain, stiffness and discomfort significantly reduce after the 1st session (1 hour), but for
            long term results we recommend using the device for at least 14 days (1 hour/day).
            90% of our customers completely got rid of sciatica & lower back pain after using the Hugterra
            Massager every day for 14 days.
            Fixing the root cause of pain requires consistency above all else.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">How do I
            use it?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            1.Wrap the Hugterra Belt around your lower back and secure it with the adjustable straps.
            2.Press the ON button, then select your preferred heat and massage intensity level.
            3.Sit, walk or lie down comfortably while the belt works for 1 hour.
            4.Use daily for 7-14 days, then as needed for ongoing relief and spinal support.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">How is it
            powered?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The Hugterra™ Massager has a built-in rechargeable battery, one full battery lasts for 10-15
            sessions, a full charge takes 3-5 hours (depending on the power source). the charging cable is
            included with the product.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper" style="background-color: #eaf4f9;">
        <div data-attribute="item-question" class="item-question">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
          </span>
          <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">Do you
            sell this product on Amazon?
          </h3>
          <span data-attribute="icon-minus" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus">
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            To avoid middlemen hiking up the prices, we don't sell on marketplaces. We sell exclusively on
            our website.
            Disclaimer: Be aware that several companies produce products similar to our Hugterra massagers,
            and our products may appear on other websites, potentially causing confusion or deception.
            We, Hugterra, own the Hugterra™ trademark and are the sole authorized sellers. Purchasing from
            other websites is at the customer's risk, as we cannot guarantee quality, authenticity, or
            after-sales service. Other massagers may look similar but may have different specifications,
            putting customers at further risk.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
